<template>
   <div id="cpproductorderdetail">
      <el-form ref="subjectDto" :model="subjectDto"  label-width="80px" class="zcyhtk" label-position="right" size="small">
            <div class="ddxqpllist" v-for="(item, index) in subjectDto.orderGoodsVoList" :key="index">
               <span class="biaotiys" v-if="item.goodsType == 0">产品</span>
               <span class="biaotiys" v-else>配件</span>
               <div class="neirongyang">
                  <p>名称：<span>{{item.proName}}</span></p>
                  <p>数量：<span>{{item.quanTity}}</span></p>
                  <p>售价：<span style="color: red;">{{item.totalPayment}}</span></p>
                  <p>规格：<span>{{item.specifications}}</span></p>
                  <p><img :src="item.proImage" alt="" class="image-column"></p>
               </div>
               <div>
               <span class="biaotiys"  v-if="item.orderPartsVoList">配件</span>
               <div class="neirongyang"  v-for="(item2, index) in item.orderPartsVoList" :key="index">
                  <p>名称：<span>{{ item2.partsName }}</span></p>
                  <p>数量：<span>{{ item2.partsCount }}</span></p>
                  <p>售价：<span style="color: red;">{{ item2.unitPrice }}</span></p>
                  <p>规格：<span>{{ item2.partsSpecifications }}</span></p>
                  <p><img :src="item2.partsImage" alt="" class="image-column"></p>
               </div>
            </div>
            </div>
               <el-form-item label="收货人姓名：">
                  <el-input v-model="subjectDto.receiveName" disabled></el-input>
               </el-form-item>
               <el-form-item label="收货人手机号：">
                  <el-input v-model="subjectDto.receivePhone" disabled></el-input>
               </el-form-item>
               <el-form-item label="收货人地址：">
                  <el-input v-model="subjectDto.address" disabled></el-input>
               </el-form-item>
               <el-form-item label="意向单编号：">
                  <el-input v-model="subjectDto.orderCode" disabled></el-input>
               </el-form-item>
               <el-form-item label="付款金额：">
                  <el-input v-model="subjectDto.payment" disabled></el-input>
               </el-form-item>
               <el-form-item label="下单时间：">
                  <el-input v-model="subjectDto.orderDate" disabled></el-input>
               </el-form-item>
               <el-form-item label="意向单状态：">
                  <el-switch
                  v-model="subjectDto.status"
                  active-color="#13ce66"
                  inactive-color="#DBDBDB"
                  active-value="1"
                  inactive-value="0"
                  disabled>
                  </el-switch>
               </el-form-item>
               <el-form-item label="回复状态：">
                  <el-switch
                  v-model="subjectDto.replyStatus"
                  active-color="#13ce66"
                  inactive-color="#DBDBDB"
                  active-value="1"
                  inactive-value="0"
                  disabled>
                  </el-switch>
               </el-form-item>
               <el-form-item label="备注信息：">
                  <el-input v-model="subjectDto.remark" disabled></el-input>
               </el-form-item>
               <el-form-item label="回复人员：" v-if="isReadonly ==true">
                  <el-input v-model="subjectDto.replyUserName" disabled></el-input>
               </el-form-item>
               <el-form-item label="库存编号：">
                  <el-input v-model="subjectDto.specSku" disabled></el-input>
               </el-form-item>
               <div class="ddxqdeyans">
               <el-form-item label="意向单反馈：">
                  <el-input
                     type="textarea"
                     :disabled="isReadonly"
                     :autosize="{ minRows: 2, maxRows: 4}"
                     v-model="feedBackDto.messageContent">
                  </el-input>
               </el-form-item>
               </div>
      </el-form>
      <div slot="footer" style="margin-left: 40px">
         <el-button type="primary" v-if="isReadonly ==false"  @click="submitForm('subjectDto',subjectDto)">确 定</el-button>
         <el-button @click="xgtkdfdqx">取 消</el-button>
      </div>
   </div>
   </template>
   <script>
   import ipConfig from "../../utils/ipconfig";
      export default {
      name:'cpproductorderdetail',
      data(){
       return{
          queryOrderDto:{
             pageNum:1,
             pageSize:10,
             endDate:null,
             orderCode:null,
             startDate:null,
             status:null,
          },
          tableData: [],
          totals:10,
          subjectDto:{},
          feedBackDto:{
            messageContent:null,
            messageType:0,
            orderId:null
          },
          orderGoodsVoList:[],
          isReadonly: false,
          statusoptions:[
            {
               label:'待处理',
               value:'0'
            },
            {
               label:'已处理',
               value:'1'
            },
         ],
         status:null
       }
      },
      created(){
       this.status = this.$route.query.status
       this.feedBackDto.orderId = this.$route.query.orderId
       this.bjtsClick()
      },
      mounted(){
      },
      beforeRouteUpdate(to, from, next) {
         if (to.query.orderId !== from.query.orderId) {
            this.feedBackDto.orderId = to.query.orderId;
            this.bjtsClick()
         }
         next();
      },
      methods:{
       submitForm(formName){
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.tjfkaddFeedback(this.feedBackDto).then((res) => {
                if (res.data.code == 200) {
                    this.subjectDto={}
                    this.feedBackDto={
                        messageContent:null,
                        messageType:0,
                        orderId:null
                    }
                    this.xgtkdfdqx()
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            }
         });
      },
      bianjiClick(row) {
         // this.feedBackDto.orderId = row.orderId
         // this.dialogFormVisible = true;
         // this.bjtsClick(row.orderId)
      },
      goodsClick(row){
         this.orderGoodsVoList = row.orderGoodsVoList
      },
      bjtsClick(){
         this.$api.orderDetail({
            orderId:this.feedBackDto.orderId
            }).then((res)=>{
               if (res.data.code == 200) {
                  let data = res.data.data
                  if (data.status == 1) {
                     this.feedBackDto.messageContent = data.chatMessageContent
                     this.isReadonly = true
                  }
                  data.orderGoodsVoList.forEach(element => {
                     if (element.proImage.startsWith('https')) {
                        element.proImage = element.proImage;
                     } else {
                        element.proImage = ipConfig.baseUrl+element.proImage;
                     }
                     if (element.orderPartsVoList) {
                        element.orderPartsVoList.forEach(item => {
                           if (item.partsImage.startsWith('https')) {
                              item.partsImage = item.partsImage;
                           } else {
                              item.partsImage = ipConfig.baseUrl+item.partsImage;
                           }
                        });
                     }
                  });
                  if (data.status==0) {
                     data.status = '0'
                  }else{
                     data.status = '1'
                  }
                  if (data.replyStatus==0) {
                     data.replyStatus = '0'
                  }else{
                     data.replyStatus = '1'
                  }
                  data.receiveName = data.shoppingDetailVo.receiveName;
                  data.receivePhone = data.shoppingDetailVo.receivePhone;
                  data.address = data.shoppingDetailVo.receiveProvince+
                  data.shoppingDetailVo.receiveCity+
                  data.shoppingDetailVo.receiveStrict+
                  data.shoppingDetailVo.receiveAddress;
                  this.subjectDto = data
               } else {
                  this.$message.error(res.data.message)
               }
         })
      },
      dels(e) {
         this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.$api.dddelete({
            orderId:e.orderId
               }).then((res) => {
               if(res.data.code==200){
                  this.$message.success(res.data.message)
               }else{
                  this.$message.error(res.data.message)
               }
            })
         }).catch(() => {
            this.$message({
               type: 'info',
               message: '已取消删除'
            });
         });
      },
      xgtkdfdqx(){
         this.subjectDto={
            activeDate:null,
            endDate:null,
            remark:null,
            subContent:null,
            subhead:null,
            subjectTitle:null,
            status:0,
            subjectId:null
         }
         this.feedBackDto={
            messageContent:null,
            messageType:0,
            orderId:null
          },
         this.isReadonly = false
         this.feedBackDto.messageContent = null
         this.$router.push({
            path: "cpproductorder",
         });
      },
      }
   }
   </script>
   <style scoped>
   #cpproductorderdetail {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      background-color: #fff;
      padding:0 0 0 30px;
      box-sizing: border-box;
   }
   .tos {
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      /* background: yellow; */
      margin-bottom: 20px;
      margin-left: -30px;
   }
   .elrow{
      box-sizing: border-box;
      width: 20%;
      margin-top: -6px;
      margin: 0 40px 0 20px;
   }
   .elrowleft{
      width: 80%;
      float: left;
      box-sizing: border-box;
   }
   .elrowleft input{
      border: 2px solid #1b93ed !important;
      border-radius: 0 !important;
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #929da5;
      box-sizing: border-box;
      color: #1f3d35;
      font-size: 14px;
      height: 36px;
      line-height: 1;
      outline: none;
      padding: 3px 10px;
      transition: border-color .2s cubic-bezier(.645,.045,.355,1);
   }
   .elrowcontent{
      width: 16.66667%;
      float: left;
      box-sizing: border-box;
   }
   .search-btn {
      height: 36px;
      width: 100px;
      background: #1b93ed;
      border: 2px solid #1b93ed;
      margin: 0;
      padding: 0;
      color: #fff;
      cursor: pointer;
   }
   .right-item {
      margin-left: auto; /* Pushes the item to the right */
   }
   .tos /deep/ .el-form-item {
      margin-bottom: 0 !important;
   }
   .btnbox {
      /* background: pink; */
      display: flex;
      width: 40%;
      align-items: center;
      justify-content: space-around;
      margin: auto;
      margin-top: 30px;
   }
   .zcyhtk /deep/ .el-form-item__label {
      width: 120px !important;
   }
   .zcyhtk /deep/ .el-form-item__content {
      margin-left: 120px !important;
   }
   .ddxqdeyans{
      border-top: #DCDCDC 1px solid;
      padding-top: 30px;
   }
   .ddxqpllist{
      background-color: #F9F9F9;
      padding: 20px;
      margin-bottom: 30px;
      color: #333333;
      font-size: 16px;
   }
   .ddxqpllist .biaotiys{
      color: #0889FD;
      margin: 0;
      margin-bottom: 20px;
      font-weight: 600;
   }
   .neirongyang{
      display: flex;
   }
   .neirongyang p{
      margin: 0;
      line-height: 25px;
   }
   .neirongyang p:nth-child(1){
      width: 30%;
   }
   .neirongyang p:nth-child(2){
      width: 15%;
   }
   .neirongyang p:nth-child(3){
      width: 15%;
   }
   .neirongyang p:nth-child(4){
      width:25%;
   }
   .neirongyang p:nth-child(5){
      width: 10%;
   }
   .image-column {
      width: 50px;
      height: 50px;
      object-fit: cover; /* 保持图片比例填充 */
   }
   </style>



// WEBPACK FOOTER //
// src/components/cpproductorder/cpproductorderdetail.vue